var exports = {
  "k5": "ProjectItemSectionViewContainer__k8at_R",
  "fe": "projectTitleText__RkTimD",
  "KK": "truncatedProjectTitle__1l65L2",
  "V4": "projectLinkContainer__YOUwa7",
  "Y": "projectLink__MfDoXu",
  "PA": "Truncate__9PtTP0",
  "WA": "statusFieldContainer__gwyTav",
  "xt": "statusFieldLoading__LhWgrY",
  "rc": "projectFieldsToggle__J80Fzx",
  "tg": "closedLabel__deEAJZ",
  "VJ": "projectIcon__MeiWoM",
};

module.exports = exports;
